// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eyebrow[data-v-641a751e]{background:#fff;padding:15px 20px}.eyebrow__label[data-v-641a751e]{color:#656e8b;font-size:13px;font-weight:700;line-height:1;text-transform:uppercase}.eyebrow__title[data-v-641a751e]{color:#313b59;font-size:24px;font-weight:700;line-height:1.2;margin-top:2px}.eyebrow__title[data-v-641a751e]:focus{outline:none}.eyebrow__subtitle[data-v-641a751e]{color:#656e8b;font-size:14px;line-height:1.1;margin-top:2px}", ""]);
// Exports
module.exports = exports;
